import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, SYNC_SUFFIX } from "@obg/ngrx-utils";

const ACTION_PREFIX = "[Cookie Notice]";
export const COOKIE_NOTICE_ACTION_TYPE = {
	setEnabled: `${ACTION_PREFIX} Set Enabled ${SYNC_SUFFIX}`,

	close: `${ACTION_PREFIX} Close ${SYNC_SUFFIX}`,

	show: `${ACTION_PREFIX} Show ${SYNC_SUFFIX}`,
};

@Injectable({
	providedIn: "root",
})
export class CookieNoticeAction {
	setEnabled(isEnabled: boolean): ActionWithPayload {
		return {
			type: COOKIE_NOTICE_ACTION_TYPE.setEnabled,
			payload: isEnabled,
		};
	}

	show(): Action {
		return {
			type: COOKIE_NOTICE_ACTION_TYPE.show,
		};
	}

	close(): Action {
		return {
			type: COOKIE_NOTICE_ACTION_TYPE.close,
		};
	}
}
